import CloseIcon from "@mui/icons-material/Close";
import { Fade, IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Modal from "@mui/material/Modal";
import * as React from "react";
import { useSelector } from "react-redux";
import { commonActions } from "../../../../redux/reducers/CommonReducer";
import store from "../../../../redux/Store";
import classes from "./SideModal.module.css";

const SideModal = () => {
  const sideModal = useSelector((state) => state.common.sideModal);

  // if modalCloseMessage exists use it, else use default close
  const handleClose = () => sideModal?.modalCloseMessage ? sideModal?.modalCloseMessage() : store.dispatch(commonActions.closeSideModal());

  return (
    <div>
      <Modal open={sideModal.isShowModal} onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}>
        <Fade in={sideModal.isShowModal}>
          <Box className={classes.sideModal}>
            <Box className={classes.headerContainer}>
              <IconButton className={classes.closeButton} onClick={handleClose}>
                <CloseIcon />
              </IconButton>
              <div className={classes.header}>
                <img
                  src={sideModal.modalHeader?.icon}
                  className={classes.headerIcon}
                />
                <div className={classes.headerContent}>
                  <div className={classes.title}>
                    {sideModal.modalHeader?.title}
                  </div>
                  <div className={classes.subTitle}>
                    {sideModal.modalHeader?.subTitle}
                  </div>
                  {sideModal.modalHeader && sideModal.modalHeader.progress && (
                    <Box>
                      <LinearProgress
                        classes={{
                          colorPrimary: classes.colorPrimary,
                          barColorPrimary: classes.barColorPrimary,
                        }}
                        className={classes.progressBar}
                        variant="determinate"
                        value={
                          sideModal.modalHeader
                            ? sideModal.modalHeader.progress
                            : 0
                        }
                      />
                    </Box>
                  )}
                </div>
              </div>
            </Box>
            {sideModal.modalContent && (
              <Box className={classes.contentContainer}>
                {sideModal.modalContent}
              </Box>
            )}
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default SideModal;
